import {INTERNAL_CLOCK} from './types';

export const getInternalClock = (paylod: {
  difference_time_stamp: string | number;
}) => ({
  type: INTERNAL_CLOCK,
  payload: paylod,
});
